export enum IFormRequestType {
    Contact = 0,
    Service = 1,
    Quote = 2
}